module.exports = __webpack_public_path__ + "4bccd880cf33d0ddb41a833d8a09e82f.svg";